/**
 * Renders the assign contract personnel page
 */

import React from 'react';

import BodyContainer from '@seccon/shared/ui/components/BodyContainer';

import { FiltersProvider } from './contexts/filters';
import PersonnelList from './components/PersonnelList';
import Filters from './components/Filters';
import Header from './components/Header';

import { ContractInfoProvider } from './contexts/contractInfo';

const AssignContractPersonnel = () => (
  <BodyContainer>
    <ContractInfoProvider>
      <FiltersProvider>
        <Header />
        <Filters />
        <PersonnelList />
      </FiltersProvider>
    </ContractInfoProvider>
  </BodyContainer>
);

export default AssignContractPersonnel;
